import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Categories, GamesCard, Providers } from ".";

const ProviderModal = ({
  providerModalConfig,
  setProviderModalConfig,
  data,
}) => {
  const [activeProvider, setActiveProvider] = useState(null);
  const [isSearched, setIsSearched] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(() => {
    setActiveProvider(providerModalConfig?.defaultActiveProvider);
  }, [providerModalConfig]);

  const handleSearch = (value) => {
    if (!value) {
      setIsSearched(false);
      return;
    }
    setIsSearched(true);
    let searchedArr = [];
    for (let key in data) {
      if (Providers?.some((s) => s?.key === key)) {
        for (let childKey in data?.[key]) {
          if (Categories?.some((s) => s?.key === childKey)) {
            searchedArr = [
              ...searchedArr,
              ...data?.[key]?.[childKey]?.filter(
                (f) =>
                  f?.name?.toLowerCase()?.indexOf(value?.toLowerCase()) > -1,
              ),
            ];
          }
        }
      }
    }
    setFilteredItems(searchedArr);
  };

  return (
    <Modal
      show={Boolean(providerModalConfig?.showModal)}
      keyboard={false}
      backdrop={"static"}
      centered
      onHide={() => setProviderModalConfig((p) => ({ ...p, showModal: false }))}
      className="ProviderModal"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div>
          <input
            placeholder="Search Game.."
            onChange={({ target }) => handleSearch(target.value)}
          />
          <ul className="d-flex ProviderTabs">
            {Providers.filter((f) =>
              Object.keys(data).some((s) => s == f?.key),
            )?.map((pvd, idx) => {
              return (
                <li
                  key={idx}
                  className={
                    activeProvider && pvd?.key === activeProvider?.key
                      ? "active"
                      : ""
                  }
                  role="button"
                  onClick={() => setActiveProvider(pvd)}
                >
                  <img src={pvd?.img} alt={pvd?.name} />
                  {pvd?.name}
                </li>
              );
            })}
          </ul>

          {!isSearched ? (
            <div className="CasinoGameSliderSection ">
              {data?.[activeProvider?.key] &&
                Categories?.filter((f) =>
                  Object.keys(data?.[activeProvider?.key]).some(
                    (s) => s === f?.key,
                  ),
                )?.map((ctg, idx) => {
                  return (
                    <div key={idx} className="CasinoGameSlider">
                      <div className="d-flex CategoryHeading">
                        <div className=" d-flex justify-content-center heading">
                          <div class="dashed-line"></div>
                          <div className="CategoryName">{ctg?.name}</div>
                          <div class="dashed-line"></div>
                        </div>
                      </div>

                      <div className="d-flex ModalImgBox">
                        {data?.[activeProvider?.key]?.[ctg?.key] &&
                          data?.[activeProvider?.key]?.[ctg?.key]?.map(
                            (game, idx) => {
                              return <GamesCard card={game} key={idx} />;
                            },
                          )}
                      </div>
                    </div>
                  );
                })}
            </div>
          ) : (
            <div className="CasinoGameSliderSection ModalImgBox">
              {filteredItems?.length > 0 ? (
                filteredItems.map((game, idx) => {
                  return <GamesCard card={game} key={idx} />;
                })
              ) : (
                <p>No match found</p>
              )}
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ProviderModal;
